/**
 * Sidebar menu keys — keep in sync with zra-api/src/utils/sidebarMenuConfig.js
 */

export const SIDEBAR_MENU_ITEMS = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'vat', label: 'VAT' },
  { key: 'infrastructure-tax', label: 'Infrastructure Tax' },
  { key: 'tasks', label: 'Tasks' },
  { key: 'properties', label: 'Properties' },
  { key: 'taxpayers', label: 'Taxpayers' },
  { key: 'fto-entities', label: 'FTO entities' },
  { key: 'pms-suppliers', label: 'PMS Suppliers' },
  { key: 'bookings', label: 'Bookings' },
  { key: 'visitors', label: 'Visitors' },
  { key: 'search', label: 'Search' },
  { key: 'help', label: 'Help' },
  { key: 'sync-dashboard', label: 'Sync Dashboard' },
  { key: 'admin', label: 'Admin', lockVisible: true },
];

/** Matches API default when setting is unset. */
export const SIDEBAR_MENU_HIDDEN_DEFAULT = ['vat', 'infrastructure-tax'];
